export default function switchAccountsUrl(pathname, search) {
  const epParam = `ep=${encodeURIComponent(pathname + search)}`;
  const sep = search ? '&' : '?';
  return `/user/account/select${search}${sep}${epParam}`;
}
